import React, { useEffect, useState } from "react";
import { DECKS, getDeck } from "./decks/index";
import Home from "./components/Home";
import PasswordGate from "./components/PasswordGate";

// ─── Simple hash-based router (no dependencies needed) ───────────
// URLs:
//   interactive.catalystmeded.com/              → Home (deck index)
//   interactive.catalystmeded.com/belitebio-2026 → BeLite Bio deck
//
// Vercel rewrites all paths to index.html (via vercel.json),
// then we read window.location.pathname here.

export default function App() {
  const [slug, setSlug] = useState(() => {
    const path = window.location.pathname.replace(/^\//, "").replace(/\/$/, "");
    return path || null;
  });

  // Listen for browser back/forward
  useEffect(() => {
    const onPop = () => {
      const path = window.location.pathname.replace(/^\//, "").replace(/\/$/, "");
      setSlug(path || null);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  // Navigate helper — usable by Home to push a deck route
  const navigate = (newSlug) => {
    const url = newSlug ? `/${newSlug}` : "/";
    window.history.pushState({}, "", url);
    setSlug(newSlug || null);
  };

  // No slug → show home
  if (!slug) {
    return <Home decks={DECKS} navigate={navigate} />;
  }

  // Known slug → render deck (wrapped in per-deck password gate)
  const deck = getDeck(slug);
  if (deck) {
    const DeckComponent = deck.component;
    return (
      <PasswordGate slug={slug}>
        <DeckComponent onHome={() => navigate(null)} />
      </PasswordGate>
    );
  }

  // Unknown slug → 404
  return <NotFound navigate={navigate} />;
}

function NotFound({ navigate }) {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#121531",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      fontFamily: "'Georgia', serif",
      color: "#8892A4",
      gap: 20,
    }}>
      <div style={{ fontSize: 64, opacity: 0.2 }}>404</div>
      <div style={{ fontSize: 16, color: "#F4F6FA" }}>Deck not found.</div>
      <button onClick={() => navigate(null)} style={{
        background: "rgba(66,164,217,0.1)",
        border: "1px solid rgba(66,164,217,0.3)",
        borderRadius: 8,
        color: "#42A4D9",
        fontSize: 13,
        padding: "10px 24px",
        cursor: "pointer",
      }}>← Back to all decks</button>
    </div>
  );
}
